export default __webpack_public_path__ + "static/media/Heaven's Dang Pa.45ca9807.jpg";